import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FeatherModule } from 'angular-feather';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'app-save-button',
    templateUrl: './save-button.component.html',
    styleUrls: ['./save-button.component.scss'],
    standalone: true,
    imports: [
        NgClass,
        NgIf,
        FeatherModule,
    ],
})
export class SaveButtonComponent {
	@Input() state: 'error' | 'incomplete' | 'unchanged' | 'changed' | 'saving' | 'saved' = 'unchanged'
	@Output() submit = new EventEmitter()
	@Input() create: boolean = false
	@Input() classes: string = ''
	save() {
		this.submit.next(true)
	}
}
